import React, { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    getTime,
    selectDropdownStyle,
    getBranchId
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";

import { getAllFranchisee } from "../../../Helpers/apiCalls/franchiseeApi";
import { searchWastage, deleteWastage } from "../../../Helpers/apiCalls/Reports/DailyWastageApi";
import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import { getAllItems } from "../../../Helpers/apiCalls/itemsApi";
import { searchDailyUsage } from './../../../Helpers/apiCalls/Reports/DailyUsageApi';
import Footer from "../../../Components/Footer/Footer";
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination";

export default function DailyUsage() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();

    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
        date_from: dateToday,
        date_to: dateToday,
        page: 1
    })
    const [branches, setBranches] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [allData, setAllData] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState([]);
    const [averagePrice, setAveragePrice] = useState([]);
    const [totalAmount, setTotalAmount] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState({
        label: "", 
        value: ""
    });
    const [items, setItems] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };

    async function fetchBranches() {
        setBranches([])
        const response = await getAllBranches();
        if (response.data) {
            var allBranches = response.data.data.data
            .filter((data) => { return data.is_franchise !== "3"})
            .map((data) => {
                var branch = data;
                branch.label = data.name
                branch.value = data.id
                return branch;
            });

            if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
                var filteredBranch = allBranches.filter((data) => {
                    return data.value === getBranchId()
                })
                setBranches(filteredBranch);
            } else {
                setBranches([{label: "All Branches", value:""}, ...allBranches]);
            }

        }
    }
    
    async function fetchAllItems() {
        setItems([])
        const response = await getAllItems();

        if (response.response.data) {
            var data = response.response.data
            .filter((data) => {
                return data.type === "ingredient"
            })
            .map((item) => {
                var info = item;
                info.label = item.name
                info.value = item.id
                return info;
            });
            setItems([{label: "All Items", value:""}, ...data]);
        }
    }

    async function fetchData() {
        setShowLoader(true);
        setAllData([])
        setTotalQuantity(0);
        setTotalItems(0)

        const response = await searchDailyUsage(filterConfig);
        if (response.data) {

            var allBills = response.data.data.map((bill) => {
                var items = ""
                var info = bill;
                info.order_date = Moment(bill.added_on).format("MM-DD-YYYY")
                info.time = getTime(bill.added_on)
                info.usage_qty = numberFormat(bill.usage_qty)
                return info;
            });
            
            setAllData(allBills)
            setTotalItems(response.data.size);

            var total = response.data.total_usage_qty;
            setTotalQuantity(total);
        }
        setShowLoader(false);
    }

    useEffect(() => {
        fetchBranches();
        fetchAllItems()
    }, []);

    useEffect(() => {
        fetchData();
    }, [filterConfig, currentPage]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"STORE INVENTORY"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> DAILY USAGE </h1>
                    </Col>
                </Row>

                <div className="tab-content">
                    {/* filters */}
                    
                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                        <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Branch"
                            styles={selectDropdownStyle}
                            value={selectedBranch}
                            options={branches}
                            onChange={(e) => {setSelectedBranch({label: e.label, value: e.value})}}
                        />
                        </Col>
                        <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Item"
                            styles={selectDropdownStyle}
                            // value={branch}
                            options={items}
                            onChange={(e) => { setFilterConfig((prev) => {
                                    return { ...prev, "item_id": e.value };
                                });}}
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_from}
                            name="date_from"
                            placeholderText={"Select Date"}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_from: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter me-4 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_to}
                            name="date_to"
                            placeholderText={"Select Date"}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_to: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter ps-label-content me-5 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                    </Row>
                    <div className="mb-2" />

                    <div className=" PO-filters d-flex justify-content-center">
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total Usage Quantity: {numberFormat(totalQuantity)}
                        </span>
                    </div>

                    <div className="below">
                        {/* table */}
                        <TableWithDynamicPagination
                            tableHeaders={[
                                "ORDER NO.",
                                "BRANCH",
                                "ITEM",
                                "USAGE QTY",
                                "ORDER DATE",
                                "TIME",
                            ]}
                            headerSelector={[
                                "order_id",
                                "branch_name",
                                "item_name",
                                "usage_qty",
                                "order_date",
                                "time",
                            ]}
                            tableData={allData}
                            showLoader={showLoader}
                            // used in dynamic pagination
                            totalItems={totalItems}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            handlePageChange={handlePageChange}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
            </div>
            <Footer/>
        </div>
    );
}
